import demo from './demo';
import local from './local';
import dev from './dev';
import staging from './staging';
import prod from './prod';


// Vite mode replaces the former REACT_APP_ENV:
//   `vite build` (mode "production") -> prod, `--mode staging|demo|dev`,
//   `--mode localhost` -> local (Vite reserves the mode name "local").
// `vite` dev server (mode "development") and unknown modes use dev, as before.
// import.meta.env.MODE is a build-time constant, so unused configs are dropped.
export const APP_ENV = import.meta.env.MODE;

const selectConfig = () => {
  if (import.meta.env.MODE === 'production') {
    return prod;
  }
  if (import.meta.env.MODE === 'staging') {
    return staging;
  }
  if (import.meta.env.MODE === 'localhost') {
    return local;
  }
  if (import.meta.env.MODE === 'demo') {
    return demo;
  }
  return dev;
};

const appConfig = selectConfig();

export { appConfig as default };
